import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import SAVE_PROVIDER_PREFERENCE_QUERY from './SaveProviderPreference.gql';

const parseResult = (result) => {
  const initialState = {};

  const providerPreferencePostResponse = get(
    result,
    'core.providerPreferenceDetails.saveProviderPreference'
  );
  return {
    ...initialState,
    ...providerPreferencePostResponse,
  };
};

export const useSaveProviderPreferenceQuery = (options) => {
  const [queryResult, queryAction] = useQuery(SAVE_PROVIDER_PREFERENCE_QUERY, {
    ...options,
    requestPolicy: 'no-cache',
    onCompleted: (result) => {
      options.onCompleted(parseResult(result.body.data));
    },
  });
  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
